/* Funventory conversion helpers, loaded on every page from layout/theme.liquid (after fv-global.js).
   1. Cart drawer: always slides over the page (never squeezes it), closes when the dimmed page is clicked,
      and doesn't re-open by itself on the next page.
   2. Cart drawer: free-delivery progress bar + "cash on delivery" reassurance under Check out.
   3. Floating WhatsApp chat button (pre-fills the product name on product pages).
   4. Mobile menu: quick help links at the bottom.
   5. Collection filters: one open at a time, close when tapping outside. */
(function () {
  var WHATSAPP = '923292933222';
  var FREE_FROM = 5000 * 100; /* Rs 5,000 in paisa */

  function money(paisa) {
    return 'Rs ' + Math.round(paisa / 100).toLocaleString('en-PK');
  }
  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }
  var ICON_WA = '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.38a9.9 9.9 0 0 0 4.74 1.21c5.46 0 9.91-4.45 9.91-9.91C21.95 6.45 17.5 2 12.04 2zm5.8 14.02c-.24.68-1.42 1.3-1.95 1.35-.5.05-.97.23-3.27-.68-2.77-1.09-4.52-3.92-4.66-4.1-.13-.18-1.11-1.48-1.11-2.82 0-1.34.7-2 .95-2.27.25-.27.54-.34.72-.34h.52c.17 0 .39-.06.61.47.24.54.79 1.88.86 2.02.07.14.11.3.02.48-.09.18-.14.3-.27.46-.14.16-.29.36-.41.48-.14.14-.28.29-.12.56.16.27.7 1.16 1.51 1.88 1.04.93 1.91 1.21 2.18 1.35.27.14.43.11.59-.07.16-.18.68-.79.86-1.06.18-.27.36-.23.61-.14.25.09 1.59.75 1.86.89.27.14.45.2.52.32.07.11.07.66-.17 1.33z"/></svg>';
  var ICON_TRUCK = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 7h11v9H3zM14 10h4l3 3v3h-7"/><circle cx="7" cy="18" r="2"/><circle cx="17" cy="18" r="2"/></svg>';
  var ICON_CASH = '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="2.5" y="6" width="19" height="12" rx="2.5"/><circle cx="12" cy="12" r="2.6"/></svg>';
  var ICON_RETURN = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 9h11a5 5 0 0 1 0 10H9"/><path d="M8 5L4 9l4 4"/></svg>';

  /* ---------- 1. Cart drawer behaviour ---------- */
  ready(function () {
    var drawer = document.getElementById('cart-drawer');
    if (!drawer) return;
    /* Horizon remembers an open drawer and re-opens it on the next page. Opt the cart out. */
    drawer.setAttribute('no-persist', '');
    try {
      var saved = (sessionStorage.getItem('theme-drawer-open') || '').split(',').filter(function (id) { return id && id !== 'cart-drawer'; });
      if (saved.length) sessionStorage.setItem('theme-drawer-open', saved.join(','));
      else sessionStorage.removeItem('theme-drawer-open');
    } catch (e) {}

    /* On wide screens Horizon opens the cart as a side panel without a backdrop.
       Our CSS dims the page behind it; a click on that dimmed area closes the cart. */
    /* Only a click that STARTED while the cart was already open can close it, so the click
       that opens the cart (cart icon, Add to cart) never closes it again straight away. */
    var wasOpen = false;
    document.addEventListener('pointerdown', function () { wasOpen = drawer.hasAttribute('open'); }, true);
    document.addEventListener('click', function (e) {
      if (!wasOpen || !drawer.hasAttribute('open') || window.innerWidth < 990) return;
      var panel = drawer.querySelector('dialog');
      if (!panel || panel.contains(e.target)) return;
      if (e.target.closest && e.target.closest('[on\\:click*="cart-drawer"], .fv-toast, .fv-wa, dialog[open]')) return;
      if (typeof drawer.close === 'function') drawer.close();
    });
  });

  /* ---------- 2. Free-delivery progress + COD note ---------- */
  var lastTotal = null;
  try { var v = sessionStorage.getItem('fvCartTotal'); if (v !== null) lastTotal = Number(v); } catch (e) {}

  function barHTML(total) {
    var left = FREE_FROM - total;
    var pct = Math.max(4, Math.min(100, (total / FREE_FROM) * 100));
    var msg = left > 0
      ? 'Add <strong>' + money(left) + '</strong> more for <strong>FREE delivery</strong>'
      : '<strong>Yay! Your order ships FREE</strong>';
    return '<p class="fv-ship__msg">' + ICON_TRUCK + '<span>' + msg + '</span></p>' +
      '<div class="fv-ship__track" role="progressbar" aria-label="Progress to free delivery" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' + Math.round(pct) + '"><span style="width:' + pct.toFixed(1) + '%"></span></div>';
  }

  function decorateDrawer() {
    var drawer = document.getElementById('cart-drawer');
    if (!drawer) return;
    var summary = drawer.querySelector('.cart-drawer__summary');
    if (summary && lastTotal !== null) {
      var bar = summary.querySelector('.fv-ship');
      var done = lastTotal >= FREE_FROM;
      var html = barHTML(lastTotal);
      if (!bar) {
        bar = document.createElement('div');
        bar.className = 'fv-ship';
        summary.insertBefore(bar, summary.firstChild);
      }
      if (bar.dataset.total !== String(lastTotal)) {
        bar.innerHTML = html;
        bar.dataset.total = String(lastTotal);
      }
      bar.classList.toggle('is-done', done);
    }
    var ctas = drawer.querySelector('.cart__ctas');
    if (ctas && !ctas.parentNode.querySelector('.fv-assure')) {
      var note = document.createElement('ul');
      note.className = 'fv-assure';
      note.innerHTML = '<li>' + ICON_CASH + 'Cash on delivery</li><li>' + ICON_TRUCK + 'Ships across Pakistan</li><li>' + ICON_RETURN + '7-day returns</li>';
      ctas.parentNode.insertBefore(note, ctas.nextSibling);
    }
  }

  var refreshTimer = null;
  function refreshTotal(delay) {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(function () {
      fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) { lastTotal = Number(cart.total_price) || 0; decorateDrawer(); })
        .catch(function () {});
    }, delay || 0);
  }

  ready(function () {
    var drawer = document.getElementById('cart-drawer');
    if (!drawer) return;
    decorateDrawer();
    refreshTotal(0);
    var frame = null;
    new MutationObserver(function (list) {
      /* Ignore our own insertions. */
      var ours = list.every(function (m) {
        return Array.prototype.every.call(m.addedNodes, function (n) { return n.nodeType !== 1 || (n.closest && n.closest('.fv-ship, .fv-assure')); }) &&
          Array.prototype.every.call(m.removedNodes, function (n) { return n.nodeType !== 1 || (n.classList && (n.classList.contains('fv-ship') || n.classList.contains('fv-assure'))); });
      });
      if (ours) return;
      if (frame) return;
      frame = requestAnimationFrame(function () { frame = null; decorateDrawer(); refreshTotal(150); });
    }).observe(drawer, { childList: true, subtree: true });
    document.addEventListener('theme-drawer:open', function () { refreshTotal(0); });
  });

  /* ---------- 3. Floating WhatsApp button ---------- */
  ready(function () {
    if (document.querySelector('.fv-wa')) return;
    var text = 'Hi Funventory! I have a question about a toy.';
    var tpl = document.querySelector('main[data-template]');
    var isProduct = tpl && /^product/.test(tpl.getAttribute('data-template') || '');
    if (isProduct) {
      var h1 = document.querySelector('main h1');
      if (h1) text = 'Hi Funventory! I want to order: ' + h1.textContent.trim() + ' (' + location.origin + location.pathname + ')';
    }
    var a = document.createElement('a');
    a.className = 'fv-wa';
    a.href = 'https://wa.me/' + WHATSAPP + '?text=' + encodeURIComponent(text);
    a.target = '_blank';
    a.rel = 'noopener';
    a.setAttribute('aria-label', 'Chat with us on WhatsApp');
    a.innerHTML = ICON_WA + '<span class="fv-wa__label">' + (isProduct ? 'Order on WhatsApp' : 'Chat with us') + '</span>';
    document.body.appendChild(a);
  });

  /* ---------- 4. Mobile menu: help links ---------- */
  ready(function () {
    var nav = document.querySelector('.menu-drawer .menu-drawer__navigation');
    if (!nav || nav.parentNode.querySelector('.fv-menu-help')) return;
    var box = document.createElement('div');
    box.className = 'fv-menu-help';
    box.innerHTML =
      '<a class="fv-menu-help__wa" href="https://wa.me/' + WHATSAPP + '?text=' + encodeURIComponent('Hi Funventory! I need help choosing a toy.') + '" target="_blank" rel="noopener">' + ICON_WA + '<span><strong>Need help choosing?</strong><small>Chat with us on WhatsApp</small></span></a>' +
      '<ul class="fv-menu-help__perks"><li>' + ICON_TRUCK + 'Free delivery over Rs 5,000</li><li>' + ICON_CASH + 'Cash on delivery</li></ul>';
    nav.parentNode.insertBefore(box, nav.nextSibling);
  });

  /* ---------- 5. Collection filters ---------- */
  ready(function () {
    var filters = Array.prototype.slice.call(document.querySelectorAll('.fvcg__f'));
    if (!filters.length) return;
    filters.forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (d.open) filters.forEach(function (o) { if (o !== d) o.open = false; });
        document.documentElement.classList.toggle('fv-filter-open', filters.some(function (o) { return o.open; }));
      });
      var close = document.createElement('button');
      close.type = 'button';
      close.className = 'fvcg__close';
      close.setAttribute('aria-label', 'Close');
      close.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
      close.addEventListener('click', function () { d.open = false; });
      var panel = d.querySelector('.fvcg__panel');
      var summary = d.querySelector('summary');
      if (panel) {
        panel.insertBefore(close, panel.firstChild);
        if (summary) panel.setAttribute('data-title', summary.textContent.trim());
      }
    });
    document.addEventListener('click', function (e) {
      filters.forEach(function (d) { if (d.open && !d.contains(e.target)) d.open = false; });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') filters.forEach(function (d) { d.open = false; });
    });
  });

  /* ---------- 6. Sideways product rows: load every card photo before it is swiped into view ---------- */
  ready(function () {
    var rows = document.querySelectorAll('.fvc__track, .fv-cards, .fvcc__track');
    if (!rows.length) return;
    function eager(row) {
      row.querySelectorAll('img[loading="lazy"]').forEach(function (img) { img.loading = 'eager'; });
    }
    if (!('IntersectionObserver' in window)) { rows.forEach(eager); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        io.unobserve(en.target);
        eager(en.target);
      });
    }, { rootMargin: '400px 0px' });
    rows.forEach(function (row) { io.observe(row); });
  });
})();
